import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Module init
const _init = () => {

    // Fade-in effect for all sections
    // Targets all sections on a page and fades them in & up once scrolled into view.
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {

                var target = entry.target;
                setTimeout(function() {

                    // Add the fade-in class to the target element
                    // Note some elements are excluded from translate animations in the
                    // ../../scss/utility/_animations.scss file as it breaks fixed positioning.
                    target.classList.add('anim-fade-in');

                    observer.unobserve(entry.target); // Stop observing once faded in

                }, 250);
            }
        });
    });
    
    // attach anim event listeners to all sections
    document.querySelectorAll('.entry-content > *, .hero-anim_wrap').forEach(child => observer.observe(child));
};

const Anim = {
    init: _init
};

export default Anim;